import {
  Alert,
  Box,
  Card,
  CardContent,
  CardHeader,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Snackbar,
  Tooltip,
  Typography,
} from '@mui/material';

import { rolesApiKeyStore } from '../../../../api/masters/roles-api-key-store';
import { FormInput } from '../../../../components/hook-form/form-input.component';
import { FormAutoCompleteSelectDynamic } from '../../../../components/hook-form/form-autocomplete-select.dynamic.component';
import { Employee } from '../../../../models/masters/employee';
import { usersApiKeyStore } from '../../../../api/users-api-key-store';
import { useFormContext, useWatch } from 'react-hook-form';
import { useEffect, useState } from 'react';
import { FormAutoCompleteMultiSelectDynamic } from '../../../../components/hook-form/form-autocomplete-multi-select.dynamic.component';
import { FormCheckbox } from '../../../../components/hook-form/form-checkbox.component';
import { GuardedComponent } from '../../../../components/guarded-component';
import { UserPermissionName } from '../../../../models/user-permission-name';
import { useAuthorize } from '../../../../hooks/use-authorize';

interface EmployeeInfo {
  employee: Employee;
  handleEpmpoyeeRestPassword?: () => void;
}
const styling = {
  textStyle: { cursor: 'pointer', fontWeight: 'normal', textDecoration: 'underline' },
};

const isDUXEnabled = process.env.REACT_APP_DUX_FLAG === 'true';
export const EmployeeInfo = ({ employee, handleEpmpoyeeRestPassword }: EmployeeInfo) => {
  const {
    control,
    setValue,
    getValues,
    formState: { errors },
  } = useFormContext();
  const [isOpen, setIsOpen] = useState(false);
  // Watch for changes in userRoles
  //   const userRoles = useWatch({ control, name: 'userRoles' });

  //   // Effect to set password values based on selected roles
  //   useEffect(() => {
  //     // Ensure userRoles is an array before calling some
  //     const hasInspectorRole = userRoles?.roleName === 'Inspector';

  //     if (hasInspectorRole) {
  //       // Hide password fields and set userPassword
  //       setValue('userPassword', 'da43&tyhgb'); // Set default password
  //       setValue('confirmPassword', 'da43&tyhgb'); // Clear confirm password
  //     } else {
  //       // For other roles, clear the password fields
  //       setValue('userPassword', '');
  //       setValue('confirmPassword', '');
  //     }
  //   }, [userRoles, setValue]);

  const removedSpace = (data: any) => {
    const newValue = data?.replace(/\s+/g, '');
    setValue('userName', newValue);
  };

  const handleRestPasswordClick = () => {
    handleEpmpoyeeRestPassword?.();
  };

  const handleRemoveRole = (roles: any[], previousRole: any[]) => {
    // Find removed roles
    const removedRoles = previousRole?.filter((prev) => !roles?.some((role) => role?.roleID === prev?.roleID));

    // Find added roles
    if (employee?.isWOScheduledForUser && removedRoles[0]?.roleDescription === 'Inspector') {
      setValue('userRoles', previousRole);
      setIsOpen(true);
    }
  };

  const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }

    setIsOpen(false);
  };

  const isSyncWithDuxPermission = useAuthorize([UserPermissionName?.SYNC_WITH_DUX]);

  return (
    <Card elevation={0}>
      <CardHeader
        className="subHead"
        title={
          <Typography variant="h3" color="textPrimary">
            EMPLOYEE INFO
          </Typography>
        }
      ></CardHeader>
      <CardContent className="formContainer">
        <Grid container spacing={2}>
          <Grid item lg={6} sm={6} xl={6} xs={6}>
            <FormInput label="First Name" name="firstName" maxLength={150} autoFocus />
          </Grid>
          <Grid item lg={6} sm={6} xl={6} xs={6}>
            <FormInput label="Last Name" name="lastName" maxLength={150} />
          </Grid>
          <Grid item lg={6} sm={6} xl={6} xs={6}>
            <FormInput
              label="User Name"
              name="userName"
              onChange={removedSpace}
              maxLength={150}
              validationQueryRoute={(value: any) => value && usersApiKeyStore.validateUserName(employee?.userID, value)}
            />
          </Grid>
          <Grid item lg={6} sm={6} xl={6} xs={6}>
            {/* <FormAutoCompleteSelectDynamic
              name="userRoles"
              label="Role"
              getQueryKeyConfig={() => rolesApiKeyStore.getRoles()}
              optionsValueKey="roleID"
              optionsLabelKey="roleName"
            /> */}
            <FormAutoCompleteMultiSelectDynamic
              name="userRoles"
              label="Role"
              getQueryKeyConfig={() => rolesApiKeyStore.getRoles()}
              optionsValueKey="roleID"
              optionsLabelKey="roleName"
              onChangeWithPrevious={(data: any, previous: any) => handleRemoveRole(data, previous)}
            />
          </Grid>
          {!employee?.userID && (
            //   userRoles?.roleName !== 'Inspector' &&
            <>
              <Grid item lg={6} sm={6} xl={6} xs={6}>
                <FormInput label="Password" type="password" name="userPassword" />
              </Grid>
              <Grid item lg={6} sm={6} xl={6} xs={6}>
                <FormInput label="Confirm Password" type="password" name="confirmPassword" />
              </Grid>
            </>
          )}
          <div onClick={() => { }} className="flex-end"></div>
          <Grid item lg={12} sm={12} xl={12} xs={12}>
            <Grid container direction="row" justifyContent="flex-end" alignItems="center">
              {isDUXEnabled && isSyncWithDuxPermission && (
                <Box>
                  <FormCheckbox label="Sync With DUX" name="syncWithDux" />
                </Box>
              )}
              <GuardedComponent requiredPermissions={[UserPermissionName.CHANGE_EMPLOYEE_PASSWORD]}>
                {!!employee?.userID && (
                  <Box mr={3} onClick={handleRestPasswordClick}>
                    <Typography variant="body2" style={styling.textStyle}>
                      Reset Password
                    </Typography>
                  </Box>
                )}
              </GuardedComponent>
              <Box>
                <FormCheckbox label="Active" name="isActive" />
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </CardContent>
      <Snackbar
        open={isOpen}
        autoHideDuration={6000}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        onClose={handleClose}
      >
        <Alert severity="error" variant="filled" sx={{ width: '100%' }} onClose={handleClose}>
          You can not remove the inspector role; this user has scheduled work orders.
        </Alert>
      </Snackbar>
    </Card>
  );
};
